import React from 'react';
import Grid from '@material-ui/core/Grid';
import OrdersChart from './OrdersChart';
import Card from '@material-ui/core/Card';

const Charts = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <Card style={{ padding: 10 }}>
          <OrdersChart />
        </Card>
      </Grid>
    </Grid>
  );
};

export default React.memo(Charts);
